import {
  BusCauHinhDonGiaDangKyPage,
  BusCauHinhDonGiaPage,
  BusCongNoPage,
  BusDangKyXePage,
  BusDiemDanhBaoCaoPage,
  BusDiemDonTraPage,
  BusLaiXePage,
  BusMonitoringPage,
  BusNhaXePage,
  BusXePage,
  HomePage,
  PhanTuyenPage,
} from './pages';

const routes = [
  { path: '/home', component: HomePage },
  { path: '/dashboard', component: HomePage },
  { path: '/bus/dashboard', component: HomePage },
  { path: '/bus/dang-ky-xe', component: BusDangKyXePage },
  { path: '/bus/xe', component: BusXePage },
  { path: '/bus/nha-xe', component: BusNhaXePage },
  { path: '/bus/lai-xe', component: BusLaiXePage },
  { path: '/bus/diem-don-tra', component: BusDiemDonTraPage },
  { path: '/bus/monitoring', component: BusMonitoringPage },
  { path: '/bus/phan-tuyen', component: PhanTuyenPage },
  { path: '/bus/bao-cao-diem-danh', component: BusDiemDanhBaoCaoPage },
  { path: '/bus/cau-hinh-don-gia', component: BusCauHinhDonGiaPage },
  { path: '/bus/cau-hinh-don-gia-dang-ky', component: BusCauHinhDonGiaDangKyPage },
  { path: '/bus/cong-no-xe-bus', component: BusCongNoPage },
];

export default routes;